export default __webpack_public_path__ + "static/media/Whatsapp.b5f547ad.png";